const messages = {
  index: {
    title: "Contactpersonen en servicenummers",
    description:
      "Wij staan voor u klaar! Hieronder vindt u de gegevens van uw Bridgestone contactpersonen en de vertegenwoordigers van uw regio.",
  },
  categories: {
    service: {
      description: "Contact met Bridgestone",
      short_desc:
        "Heeft u <span class='text-danger'>algemene vragen of opmerkingen</span> over Bridgestone PLUS, onze services of onze producten? Klikdan hieronder voor onze contactgegevens.",
    },
    contact: {
      short_desc:
        "Heeft u <span class='text-danger'>algemene vragen of opmerkingen</span> over Bridgestone PLUS, onze services of onze producten? Klik dan hieronder voor onze contactgevens",
    },
    form: {
      description:
        "Dien productklachten hier rechtstreeks in via het formulier",
    },
    touch: {
      title: "Contact Touch Incentive",
      description:
        "Heeft u een probleem met uw <span class='text-danger'>bestelling in de Bridgestone PLUS Gift Shop? (geen bandenbestellingen)</span> Hier vindt u de contactgegevens van de leverancier.",
      desc: "Heeft u een probleem met uw bestelling in de Bridgestone PLUS Gift Shop? (geen bandenbestellingen) Hier vindt u de contactgegevens van de leverancier.",
      content:
        "Indien u vragen heeft over de producten in de Bridgestone PLUS Shop, geplaatste bestellingen, levertijden of leveringen, neem dan alstublieft rechtstreeks contact op met onze leverancier: Touch Incentive Rotterdam - 010 2043075 - support&#64;touchincentive.com.",
    },
  },
  form: {
    intermediaryAddress: "Adres tussenpersoon",
    nameFirma: "Naam/Bedrijf",
    strHouseNr: "Je Straat",
    contactPerson: "Contactpersoon",
    vehicleDetails: "Informatie over het voertuig",
    vehicleTyres: "Voertuig/banden*",
    brandNew: "Gloednieuw (niet gemonteerd)",
    newItem: "Nieuw (gemonteerd)",
    fwd: "Voorwielaandrijving",
    rwd: "Achterwielaandrijving",
    awd: "Vierwielaandrijving",
    vehicleManufacturer: "Voertuigfabrikant",
    vehicleModelType: "Voertuigmodel en typeaanduiding volgens goedkeuring",
    firstRegistration: "Eerste registratie",
    enginePower: "Motorvermogen (KW bijv. 150)",
    originalEquipment: "Originele uitrusting",
    tireMilageHours: "Kilometerstand (km) / bedrijfsuren",
    tireMilage: "Kilometerstand (km)",
    tireHours: "Werk uren",
    milageOrHours: "Km of uren (bijv. 2000)",
    copyTire1: "Kopieer band 1",
    copyTire3: "Kopieer band 3",
    damageDetails: "Schadedetails",
    complaintReason: "Reden van klacht*",
    vibration: "Trillingen",
    notBalancable: "Kan niet in evenwicht zijn",
    sounds: "Geluiden",
    airPressureLost: "Verlies van luchtdruk",
    worn: "Slijtage afbeelding",
    runningPerformance: "Kilometerstand",
    deformation: "Deuken/vervormingen",
    profileBreakouts: "Profieluitbraken",
    cracks: "Scheuren",
    drivingBehavior: "Rijgedrag",
    pull: "Trekken",
    wetGrip: "Natte greep",
    defective:
      'Defecte nieuwe goederen (vermeld het nummer van de leveringsbon onder "Reden voor klachttekst")',
    otherReason: "Andere reden (geef aan onder “tekst klachtreden”)",
    isTyreReplaced: "Zijn de banden al vervangen?*",
    ifYesTyre: "Zo ja, merk vervangingsbanden",
    clerkName: "Naam van de griffier*",
    conclusion: "Diploma",
    conclusionContent:
      "<p>Deze informatie is volledig en is naar ons beste weten verstrekt.<br />Het staat vast dat de geklaagde banden op het bovengenoemde<br />voertuig zijn gereden. <br /><br /><b>De banden kunnen worden doorgesneden voor testdoeleinden. </b><br /><br /><b>Als de klacht wordt aanvaard, behouden wij ons het recht voor om<br />de banden terug te betalen na een pro rata krediet, of te compenseren met<br />een gratis vervanging levering.<br /></b><br />De goedgekeurde banden worden gesloopt. Bij afwijzing kan deze teruggevraagd worden. <br /><br />Het opslaan van bovengenoemde persoonsgegevens is toegestaan.<br /></p>",
    agreementReadAccept: "Overeenkomst gelezen en geaccepteerd.*",
    termsConditionsRead: "Lees algemene voorwaarden.",
    termsConditionsReadAccept: "Algemene voorwaarden gelezen en geaccepteerd.*",
    send: "Opslaan",
    requiredField: "*Verplicht veld",
    tires: "Banden",
    tirePosition: "Positie van de banden",
    notKnown: "Niet bekend",
    carSUVTractor: "AUTO/SUV/TRACTOR",
    CSTFrontLeft: "P/S/T-linksvoor",
    CSTFrontRight: "P/S/T-rechtsvoor",
    CSTRearLeft: "P/S/T-achter links",
    CSTRearRight: "P/S/T-achter rechts",
    motorcycle: "MOTORFIETS",
    motFront: "APK voorzijde",
    motRear: "APK achterzijde",
    truck: "SZM-vrachtwagen",
    truckSteeringAxle1Left: "Vrachtwagen stuuras 1 links",
    truckSteeringAxle1Right: "Vrachtwagen stuuras 1 rechts",
    truckSteeringAxle2Left: "Vrachtwagen stuuras 2 links",
    truckSteeringAxle2Right: "Vrachtwagen stuuras 2 rechts",
    truckDriveAxle1LeftInner: "Vrachtwagen aandrijfas 1 links binnen",
    truckDriveAxle1LeftOuter: "Aandrijfas 1 vrachtwagen links buiten",
    truckDriveAxle1RightInner: "Vrachtwagen aandrijfas 1 rechts binnen",
    truckDriveAxle1RightOuter: "Vrachtwagen aandrijfas 1, rechts buiten",
    truckDriveAxle2LeftInner: "Aandrijfas 2 vrachtwagen links buiten",
    truckDriveAxle2LeftOuter: "Vrachtwagen aandrijfas 2 links binnen",
    truckDriveAxle2RightInner: "Vrachtwagen aandrijfas 2, rechts buiten",
    truckDriveAxle2RightOuter: "Vrachtwagen aandrijfas 2 rechts binnen",
    truckTrailingAxleLeft: "Sleepas van vrachtwagen aan de linkerkant",
    truckTrailingAxleRight: "Sleepas van vrachtwagen rechts",
    trailerSemi: "AANHANGWAGEN/Oplegger",
    trailerAxle1LeftOuter: "TRAILER as 1 buiten links",
    trailerAxle1LeftInner: "TRAILER as 1 links binnen",
    trailerAxle1RightOuter: "TRAILER as 1 rechts buiten",
    trailerAxle1RightInner: "TRAILER as 1 rechts binnen",
    trailerAxle2LeftOuter: "TRAILER as 2 buiten links",
    trailerAxle2LeftInner: "TRAILER as 2 links binnen",
    trailerAxle2RightOuter: "TRAILER as 2 rechts buiten",
    trailerAxle2RightInner: "TRAILER as 2 rechts binnen",
    trailerAxle3LeftOuter: "TRAILER as 3 buiten links",
    trailerAxle3LeftInner: "TRAILER as 3 links binnen",
    trailerAxle3RightOuter: "TRAILER as 3 rechts buiten",
    trailerAxle3RightInner: "TRAILER as 3 rechts binnen",
    DOT: "DOT (specificeer ALLE 10-11 cijfers)",
    TruckSerialNo: "Serienummer. (alleen voor vrachtwagenbanden)",
    complaintReasonText: "Reden klachttekst",
    csNumberIfNeed: "Customer Number (if available)",
  },
  teams: {
    tyre: "Team bandenhandel",
    car: "Teamautodealer",
  },
  carDealers: {
    title: "Uw persoonlijke contactpersoon bij Bridgestone TEAM AUTOHAUS",
  },
};

export default {
  messages,
};
